/* eslint-disable */
import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"

import isEmpty from "lodash.isempty"
import { useParams } from "react-router-dom"

import "components/stylus/BillStatusTimeline.styl"

import { htmlParagraphToLineBreaks, htmlTablesToText, parseHtmlToReact } from "imports/desktopHelperFunctions"
import BillSummary from "profiles-new/components/BillSummary"

export const BillStatusTimeline = ({ data, id, title }) => {
    const {
        aiSummary,
        aiSummaryDate,
        aiSummarySingleSentence,
        statusTimelineData = [],
        sessionStart = "",
        sessionEnd = "",
        summary = "",
        statusDate = "",
        label = "",
        title: billTitle = "",
        currentStatus = "",
        mostRecentBillText,
    } = data.length ? data[0] : {}

    const { profileId } = useParams()

    const getSteps = () => {
        return statusTimelineData.map((status) => (
            <i
                className={classNames("timeline-item", { "timeline-item-completed": status.isCompleted })}
                data-title={status.label}
                key={status.value}
            >
                <div className={classNames("timeline-item-pdf-text", { completed: status.isCompleted })}>
                    {status.label}
                </div>
            </i>
        ))
    }

    // this will not work in IE
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex#Polyfill
    const widthVal = statusTimelineData.findIndex((i) => i.value === id)

    let numCompleted
    const statusBarLabels = statusTimelineData.map((item, idx) => {
        if (item.value === id) {
            numCompleted = idx + 1
        }
        return item.label
    })

    const parsedSummary = summary ? parseHtmlToReact(htmlParagraphToLineBreaks(htmlTablesToText(summary))) : null

    return (
        <BillSummary
            aiSummaryText={aiSummary}
            aiSummaryDate={aiSummaryDate}
            aiSummarySingleSentence={aiSummarySingleSentence}
            summaryLabel={label && (summary || billTitle) && `${label}:`}
            summaryText={
                billTitle ? (
                    <React.Fragment>
                        {billTitle}
                        <br />
                        <br />
                        {parsedSummary}
                    </React.Fragment>
                ) : (
                    parsedSummary
                )
            }
            statusBarLabels={statusBarLabels}
            statusBarNumberCompleted={numCompleted}
            statusText={currentStatus}
            statusDate={statusDate}
            sessionStartDate={sessionStart}
            sessionEndDate={sessionEnd}
            billId={profileId}
            mostRecentBillText={mostRecentBillText}
            dataType="bill"
        />
    )
}

BillStatusTimeline.propTypes = {
    data: PropTypes.array.isRequired,
    id: PropTypes.string.isRequired,
}

export default BillStatusTimeline
/* eslint-enable */
